import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchShipmentDetails } from '../../actions/shipmentsActions';

const useShipmentDetails = (shipmentId: string) => {
	const dispatch = useDispatch<any>();
	const { shipmentDetails } = useSelector(({ shipmentsReducer }) => shipmentsReducer);

	useEffect(() => {
		if (!shipmentDetails[shipmentId]) dispatch(fetchShipmentDetails(shipmentId));
	}, [shipmentDetails, shipmentId, dispatch]);

	return {
		shipmentDetails,
	};
};

export default useShipmentDetails;
